import { render, staticRenderFns } from "./ComplieRightMenu3D.vue?vue&type=template&id=444b2722&scoped=true"
import script from "./ComplieRightMenu3D.vue?vue&type=script&lang=js"
export * from "./ComplieRightMenu3D.vue?vue&type=script&lang=js"
import style0 from "./ComplieRightMenu3D.vue?vue&type=style&index=0&id=444b2722&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444b2722",
  null
  
)

export default component.exports